// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgCheckIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M18.616 6.246a1.05 1.05 0 0 0-1.14-.138 1.1 1.1 0 0 0-.375.3l-7.254 9.091-.455.559-.445-.568-2.017-2.633a1.06 1.06 0 0 0-.853-.426 1.09 1.09 0 0 0-1.07.976c-.033.29.048.582.227.813l2.273 2.965a2.367 2.367 0 0 0 3.741 0l7.52-9.414a1.117 1.117 0 0 0-.152-1.525"
    />
  </g>
);
export default SvgCheckIcon;
SvgCheckIcon.displayName = 'SvgCheckIcon';
